'use client'

import { cn } from '@/utilities/ui'
import React, { useEffect, useRef, useState } from 'react'

import type { Props as MediaProps } from '../types'

import { getMediaUrl } from '@/utilities/getMediaUrl'

export const VideoMedia: React.FC<MediaProps> = (props) => {
  const { onClick, resource, videoClassName } = props

  const videoRef = useRef<HTMLVideoElement>(null)
  // Defer the video file until it scrolls near the viewport (autoplay loops are
  // usually below the fold; this keeps multi-MB files off the initial load).
  const [inView, setInView] = useState(false)

  useEffect(() => {
    const video = videoRef.current
    if (!video || inView) return
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setInView(true)
          observer.disconnect()
        }
      },
      { rootMargin: '300px' },
    )
    observer.observe(video)
    return () => observer.disconnect()
  }, [inView])

  if (resource && typeof resource === 'object') {
    const { filename } = resource

    return (
      <video
        autoPlay
        className={cn(videoClassName)}
        controls={false}
        loop
        muted
        onClick={onClick}
        playsInline
        preload="none"
        ref={videoRef}
      >
        {inView && <source src={getMediaUrl(`/media/${filename}`)} />}
      </video>
    )
  }

  return null
}
